import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'
import { Link, useNavigate } from 'react-router-dom'

// components
import DropDown from '../../components/dropdown/DropDown'
import ScrollBtnRef from '../../components/atom/scroll/ScrollBtnRef'
import Loading from '../../components/atom/loading/Loading'

// constants
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'

// styles
import colors from '../../styles/colors'

const PrivacyTerms = () => {
  const { fetchData, loading, data, error } = useAxios()
  const navigate = useNavigate()

  const {
    fetchData: fetchDetailData,
    loading: detailLoading,
    data: detailData,
    error: detailError,
  } = useAxios()

  const user = JSON.parse(localStorage.getItem('user'))

  // 드롭다운
  const [termsDrop, setTermsDrop] = useState(null)

  // 동의
  const [agreeDate, setAgreeDate] = useState(null)

  // 개인정보약관 List
  const [privacyItem, setPrivacyItem] = useState(null)

  // api 불러오는 html 파일명
  const [privacyHtml, setPrivacyHtml] = useState(null)

  // front 있는 파일명
  const [privacyFile, setPrivacyFile] = useState(null)
  const [privacySrc, setPrivacySrc] = useState(null)
  const [privacySrcError, setPrivacySrcError] = useState(false)

  // 스크롤
  const scrollRef = useRef(null)

  // 스크롤 위 화살표 버튼 클릭
  const handleScrollUp = () => {
    if (scrollRef.current) {
      scrollRef.current.contentWindow.scrollBy(0, -300) // 원하는 만큼의 픽셀만큼 스크롤
    }
  }

  // 스크롤 아래 화살표 버튼 클릭
  const handleScrollDown = () => {
    if (scrollRef.current) {
      scrollRef.current.contentWindow.scrollBy(0, 300) // 원하는 만큼의 픽셀만큼 스크롤
    }
  }

  // 초기 화면 로드
  useEffect(() => {
    getTermDetail('P') //params 없을시 최신 날짜로 불러옴
  }, [])

  //약관 상세 데이터
  useEffect(() => {
    let resCode = data?.responseCode
    let resData = data?.responseData
    switch (resCode) {
      // 성공(데이터 O)
      case TYPE.API_RESPONSE.SUCCESS:
        if (resData) {
          const detailList = data?.responseData?.termList // 약관상세
          // const dataDateList = detailData.responseData?.termList //약관목록
          // 날짜 추출
          let dateList = detailList
            .filter((item) => item.termsType === 'P')
            .map((item) => item.termsDate)

          let formatDateList = dateList.map((item) =>
            moment(item).format('YYYY년 MM월 DD일 시행안'),
          )

          setTermsDrop(formatDateList) // dropdown 목록 설정

          setPrivacyItem(detailList.filter((e) => e.termsType === 'P'))

          const resultArr = detailList.filter((e) => e.termsType === 'P')[0]

          const privacyFileValue = `privacy_${moment(
            resultArr?.termsDate,
          ).format('YYMMDD')}.html`

          setPrivacyHtml(resultArr?.termsContents ?? null)
          setPrivacyFile(privacyFileValue) // front파일
          break
        } else {
          navigate('/error', { replace: true })
        }
      default:
        break
    }
  }, [data])

  // api: 약관 상세 (params 전달)
  const getTermDetail = (termsType) => {
    if (user) {
      // id 안넣으면 최신으로 조회
      // const params = {
      //   ...(termsDate && { termsDate }),
      // }
      const params = {
        termsType: termsType,
      }

      fetchData(
        constants.API.TERM_LIST,
        'GET', // method
        null, // body
        params, // params
      )
    }
  }

  // 드롭다운(날짜 선택)
  const handleDropdown = (opt) => {
    let replaceDate = opt.replace(/시행안|년|월|일| |/g, '')
    let finDate = moment(replaceDate).format('YYYY-MM-DD')
    // setDateRep(moment(finDate).format('YYMMDD')) // 파일 날짜 이름
    setPrivacyFile(`privacy_${moment(finDate).format('YYMMDD')}.html`)

    const selectedPrivacyItem = privacyItem.find(
      (item) => moment(item.termsDate).format('YYYY-MM-DD') === finDate,
    )

    if (selectedPrivacyItem) {
      setPrivacyHtml(selectedPrivacyItem?.termsContents)
    }
  }

  useEffect(() => {
    setPrivacySrc(`/termsHtml/${privacyFile}`)
  }, [privacyFile])

  // const htmlDecode = (html) => {
  //   try {
  //     return {
  //       __html: `<iframe src=${html}
  //       } frameborder="0" scrolling="yes" width="100%" height="400px"" </iframe>`,
  //     }
  //   } catch {
  //     alert('wihwiwi')
  //     navigate('/error')
  //   }
  // }

  return (
    <Container>
      {loading ? (
        <Loading />
      ) : (
        <>
          {privacyHtml === privacyFile ? (
            <>
              <Header>
                <TextHeader>개인정보처리방침</TextHeader>
                <ActionHeader>
                  {termsDrop && (
                    <TermDropDown
                      title={''}
                      options={termsDrop ?? ''}
                      setOption={(opt) => handleDropdown(opt)}
                    />
                  )}
                </ActionHeader>
              </Header>
              <Contents>
                <iframe
                  ref={scrollRef}
                  src={`/termsHtml/${privacyFile}`}
                  width="100%"
                />
              </Contents>
              <ScrollBtnRef
                onClickUp={() => handleScrollUp()}
                onClickDown={() => handleScrollDown()}
              />
            </>
          ) : (
            // navigate('/error')
            <></>
          )}
        </>
      )}
    </Container>
  )
}

export default PrivacyTerms

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px;
  flex: 1;

  /* height: 4000px; */
  @media ${(props) => props.theme.tablet} {
    /* height: 5100px; */
    padding: 40px;
  }
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const TextHeader = styled.div`
  font-size: 25px;
  color: ${colors.mainG};
  font-weight: bold;
`

const ActionHeader = styled.div`
  display: flex;

  @media (max-width: 800px) {
    margin-top: 10px;
  }
`

const TextAction = styled.div`
  font-size: 16px;
  color: ${colors.D3};
  display: flex;
  align-items: center;
`

const Contents = styled.div`
  margin-top: 54px;
  display: flex;
  padding: 10px 0 0 10px;
  /* height: 100%; */
  flex: 1;
`

const TermDropDown = styled(DropDown)`
  width: 232px;
  margin-left: 14px;

  .dropdown {
    margin-bottom: 0px !important;

    .show {
      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }
  }
`
